import Base from "../Base";

class TrafficInventory extends Base {

  static getComponents() {
    return {
      "inventory": require("./Parts/Inventory"),
    };
  }

}

export default TrafficInventory;
